export default __webpack_public_path__ + "static/elegant-series-fb92f8708baf813443279b9cce69751c.pdf";